import React from "react";
import ClientReportsTable from "../../features/clientreportstable";
import { useClientContext } from "../../hooks/ClientContext";
import { IconButton } from "../../components";
import { FormInputWithSearchIcon } from "../../components/forms";
import { ClientLayoutPageSubHeader, Main } from "../../components/utilities";
import { ClientReportProvider, useClientReportsList } from "../../hooks/ClientReportContext";

export const ClientReportsPageWrapper = () => {
    const { account: { adviserId, dividionId, masterAccountId } } = useClientContext();
    return (
        <ClientReportProvider 
            adviserId={adviserId}
            divisionId={dividionId}
            masterAccountId={masterAccountId}
        >
            <ClientReportsPage />
        </ClientReportProvider>
    );
};

export const ClientReportsPage = () => {
    const { showCreateModal, searchTerm, setSearchTerm } = useClientReportsList();
    const [formSearchTerm, setFormSearchTerm] = React.useState(searchTerm);
    
    React.useEffect(() => {
        const updateFilters = setTimeout(() => {
            setSearchTerm(_ => formSearchTerm);
        }, 500);
        return () => clearTimeout(updateFilters);
    }, [ formSearchTerm ]);

    return (
        <React.Fragment>
            <ClientLayoutPageSubHeader>
                <div className="d-flex justify-content-end align-items-center">
                    <FormInputWithSearchIcon
                        className="w-25 mx-1"
                        placeholder="Search for a Report."
                        value={formSearchTerm}
                        disableAnimations={true}
                        onChange={(e) => setFormSearchTerm(e.target.value)}
                    />
                    <div className="d-flex gap-1">
                        <IconButton icon="fas fa-plus" variant="success" className="ms-2" onClick={showCreateModal}>New Report</IconButton>
                    </div>
                </div>
            </ClientLayoutPageSubHeader>
            <Main className="p-3">
                <ClientReportsTable />
            </Main>
        </React.Fragment>
    );
};

export default ClientReportsPageWrapper;